(() => {
  if (window.__cartConsentInit) return;
  window.__cartConsentInit = true;

  const ATTRIBUTE = 'Digital delivery consent';
  const VALUE = 'Agreed to immediate delivery and loss of right of withdrawal';
  let saving = null;

  const saveConsent = (checked) => {
    saving = fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { [ATTRIBUTE]: checked ? VALUE : '' } }),
    })
      .catch(() => {})
      .finally(() => {
        saving = null;
      });
    return saving;
  };

  document.addEventListener('change', (event) => {
    const box = event.target.closest && event.target.closest('[data-cart-consent-checkbox]');
    if (!box) return;
    const wrapper = box.closest('[data-cart-consent]');
    const error = wrapper && wrapper.querySelector('.cart-consent__error');
    if (error) error.hidden = box.checked;
    saveConsent(box.checked);
  });

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest && event.target.closest('.cart__checkout-button, button[name="checkout"]');
      if (!button) return;
      const box = document.querySelector('[data-cart-consent-checkbox]');
      if (!box) return;

      if (!box.checked) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const wrapper = box.closest('[data-cart-consent]');
        const error = wrapper && wrapper.querySelector('.cart-consent__error');
        if (error) error.hidden = false;
        box.focus();
        return;
      }

      if (saving) {
        event.preventDefault();
        event.stopImmediatePropagation();
        saving.then(() => {
          if (button.form) button.form.requestSubmit(button);
          else button.click();
        });
      }
    },
    true
  );
})();
